/* Bulles animées du menu Plus : deux camions (désactivé / activé), zoom commun, puis bilan.
   Le mouvement est piloté en JavaScript (menuPlusHelpAnimations.js) ; ici, la mise en page et les marques. */
.tc-help { display: grid; gap: 6px; width: 470px; max-width: 100%; color: var(--color-content-copy, #334155); font-size: 0.76rem; line-height: 1.35; }
.tc-row { padding: 4px 6px 0; border: 1px solid #e2e8f0; border-radius: 4px; }
.tc-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; min-height: 20px; font-size: 0.72rem; }
.tc-head b { color: #0f172a; }
.tc-chip { padding: 1px 7px; border-radius: 4px; color: #fff; font-size: 0.68rem; font-weight: 700; white-space: nowrap; opacity: 0; transition: opacity .35s; }
.tc-chip-off { background: #c5524a; }
.tc-chip-on { background: #0f5c57; }
.tc-truck { position: relative; }
.tc-truck svg { display: block; width: 100%; height: auto; overflow: hidden; transition: opacity .4s; }
.tc-note { position: absolute; z-index: 1; left: 50%; padding: 2px 8px; border: 1.5px dashed #c5524a; border-radius: 4px; background: rgba(255, 255, 255, 0.94); color: #c5524a; font-size: 0.68rem; font-weight: 800; white-space: nowrap; opacity: 0; transform: translate(-50%, -50%); transition: opacity .3s; }
.tc-legend { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; color: #475569; font-size: 0.7rem; }
.tc-swatch { display: inline-flex; align-items: center; gap: 5px; padding: 1px 7px 1px 3px; border-radius: 4px; background: #f1f5f9; color: #0f172a; font-weight: 700; }
.tc-swatch i { width: 12px; height: 12px; border-radius: 2px; }
.tc-rules { margin: 0; padding-left: 16px; color: #64748b; font-size: 0.7rem; }
.tc-rules strong { color: #334155; }

/* Dessin du camion (menuHelpTruck.js) */
.tc-truck .cst-name { fill: #64748b; font-size: 34px; font-weight: 800; text-anchor: middle; }
.tc-truck .cst-layer { fill: #fff; font-size: 44px; font-weight: 800; text-anchor: middle; dominant-baseline: middle; paint-order: stroke; stroke: rgba(0, 0, 0, 0.45); stroke-width: 6px; }
.tc-truck .cst-out { stroke: transparent; stroke-width: 2; }
.tc-truck .cst-out[data-hot="true"] { stroke: rgba(255, 255, 255, 0.85); }
.tc-truck .cst-out[data-over="true"] { stroke: #ef4444; stroke-width: 3.5; }
.tc-truck .cst-limit { stroke: #ffc400; stroke-width: 3; stroke-dasharray: 10 7; }
.tc-truck .cst-flow { fill: none; stroke-linecap: round; stroke-dasharray: 0.1 6; animation: tc-flow .32s linear infinite; }
@keyframes tc-flow { to { stroke-dashoffset: -6.1; } }

@media (prefers-reduced-motion: reduce) {
  .tc-truck .cst-flow { animation: none; }
}
